import axios from 'axios'
import config from '../config/app'
const PATH = '/reminder'

export default {
  getCountRemindersByCompanyId (companyId) {
    return new Promise((resolve, reject) => {
      this.get({count: true, delete: 0, deactivate: 0, company_id: companyId}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getReminder (userId, type) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder/getsetting', {userId: userId, type: type}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRecentReminde (userId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder/getRecentReminder', {userId: userId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateReminder (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder/updateSetting', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCountRemindersByUserId (userId) {
    return new Promise((resolve, reject) => {
      this.get({count: true, delete: 0, deactivate: 0, user_id: userId}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  delete (reminderId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/delete', reminderId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (userId, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  status (reminderId, status) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder/status', {status: status, id: reminderId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByUser (userId, status) {
    console.log(userId)
    console.log('525252')
    console.log(status)
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/reminder/user', {userId: userId, status: status}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/reminder.js